import React, { useState, useEffect } from 'react';
import logo from '../images/logo1.png';
import './styles/login.css';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState(''); // Prefilled for testing
  const [password, setPassword] = useState(''); // Prefilled for testing
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Check if user is already logged in and redirect if needed
  useEffect(() => {
    const checkAuthState = () => {
      if (auth.currentUser) {
        console.log('User already logged in, redirecting...');
        navigate('/dashboard');
      }
    };

    // Check immediately
    checkAuthState();

    // Add listener to catch login changes
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        console.log('Auth state changed, user logged in, redirecting...');
        navigate('/dashboard');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {
      const result = await onLogin(email, password);
      if (!result.success) {
        setError(result.error);
        setIsLoading(false);
      } else if (result.redirect) {
        window.location.href = result.redirect;
      }
    } catch (err) {
      setError('Login failed. Please check your credentials and try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={logo} alt="Nuvik.io Logo" className="login-logo" />
          <h1>Log in to your account</h1>
          <p>Welcome back to Nuvik.io</p>
        </div>
        
        {error && <div className="login-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              required
            />
          </div>
          
          <div className="form-footer">
            <a href="#" className="forgot-password">Forgot password?</a>
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Log in'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>Don't have an account? <a href="/register">Create account</a></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
